import angular from 'angular';
import constants from 'app/constants';
import {
  alerts
} from 'app/components/global';
import {
  amDataService,
  loaderService,
  ssDialogService,
  userService
} from 'app/services';
import controller from './attach-finding-report-folder.controller';
import directive from './attach-finding-report-folder.directive';


export default angular.module('app.components.advisory.auditTrail.attachFindingReportFolder', [
  alerts,
  amDataService,
  constants,
  loaderService,
  ssDialogService,
  userService,
])
  .directive('amAttachFindingReportFolder', directive)
  .controller('AttachFindingReportFolderController', controller)
  .name;

console.log('app.components.advisory.auditTrail.attachFindingReportFolder created');
